// import './SideBar.less';
import './SideBar.less';

export const prefix = 'bm-c-side-bar';

export { default } from './SideBar';
